// assets
import { EnvironmentOutlined } from "@ant-design/icons";
import { ScheduleOutlined } from "@ant-design/icons";
import { TeamOutlined } from "@ant-design/icons";
import { CalendarOutlined } from "@ant-design/icons";
import { CompassOutlined } from "@ant-design/icons";
import { BarChartOutlined } from "@ant-design/icons";

// type
import { NavItemType } from "types/menu";

const icons = {
  EnvironmentOutlined,
  ScheduleOutlined,
  TeamOutlined,
  CalendarOutlined,
  CompassOutlined,
  BarChartOutlined,
};

// ==============================|| MENU ITEMS - RUNWAY ||============================== //

const runway: NavItemType = {
  id: "runway",
  title: "Runway",
  type: "group",
  children: [
    {
      id: "runway-dashboard",
      title: "Overview",
      type: "item",
      url: "/dashboard",
      icon: icons.ScheduleOutlined,
    },
    {
      id: "runway-operations",
      title: "Operations",
      type: "collapse",
      icon: icons.EnvironmentOutlined,
      children: [
        {
          id: "runway-flights-2",
          title: "Flight Schedule",
          type: "item",
          url: "/flights-2",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-crowd-prediction",
          title: "Crowd Prediction",
          type: "item",
          url: "/crowd-prediction",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-task-timeline",
          title: "Task Timeline",
          type: "item",
          url: "/task-timeline",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-staff-presence",
          title: "Staff Presence",
          type: "item",
          url: "/staff-presence",
          icon: icons.TeamOutlined,
        },
        {
          id: "runway-audit",
          title: "Audit",
          type: "item",
          url: "/audit",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-issues",
          title: "Issues",
          type: "item",
          url: "/issues",
          icon: icons.CalendarOutlined,
        },
      ],
    },
    {
      id: "runway-planning",
      title: "Planning",
      type: "collapse",
      icon: icons.CalendarOutlined,
      children: [
        {
          id: "runway-shift-roster-control",
          title: "Shift Roster",
          type: "item",
          url: "/shift-roster-control",
          icon: icons.TeamOutlined,
        },
        {
          id: "runway-task-schedule",
          title: "Task Schedule",
          type: "item",
          url: "/task-schedule",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-edit-timeline",
          title: "Edit Timeline",
          type: "item",
          url: "/edit-timeline",
          icon: icons.ScheduleOutlined,
        },
        {
          id: "runway-rescheduling",
          title: "Rescheduling",
          type: "item",
          url: "/rescheduling",
          icon: icons.CalendarOutlined,
        },
      ],
    },
    {
      id: "runway-reports",
      title: "Reports",
      type: "collapse",
      icon: icons.BarChartOutlined,
      children: [
        {
          id: "runway-reports-tasks",
          title: "Tasks",
          type: "item",
          url: "/reports/tasks",
          icon: icons.BarChartOutlined,
        },
      ],
    },
    {
      id: "runway-insights",
      title: "Insights",
      type: "collapse",
      icon: icons.CompassOutlined,
      children: [
        {
          id: "runway-traffic",
          title: "Traffic",
          type: "item",
          url: "/traffic",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-deterioration",
          title: "Deterioration",
          type: "item",
          url: "/deterioration",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-task-analysis",
          title: "Task Analysis (LH)",
          type: "item",
          url: "/task-analysis",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-task-intelligence",
          title: "Task Intelligence",
          type: "item",
          url: "/task-intelligence",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-flow-graph",
          title: "Flow Graph",
          type: "item",
          url: "/flow-graph",
          icon: icons.CompassOutlined,
        },
      ],
    },
    {
      id: "runway-tools",
      title: "Tools",
      type: "collapse",
      icon: icons.EnvironmentOutlined,
      children: [
        {
          id: "runway-map",
          title: "Pearson map",
          type: "item",
          url: "/pearson-map",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "runway-facility-map",
          title: "Facility map",
          type: "item",
          url: "/facility-map",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "runway-facility-modelling",
          title: "Facility modelling",
          type: "item",
          url: "/facility-modelling",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "runway-airport-map",
          title: "Airport map",
          type: "item",
          url: "/airport-map",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "runway-washroom-map",
          title: "Washroom map",
          type: "item",
          url: "/washroom-map",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "runway-create-task",
          title: "Create Task",
          type: "item",
          url: "/create-task",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-task-settings",
          title: "Task settings",
          type: "item",
          url: "/task-settings",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-issue-type",
          title: "Issue Type",
          type: "item",
          url: "/issue-type",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-task-settings-2",
          title: "Task settings 2",
          type: "item",
          url: "/task-settings-2",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-task-history",
          title: "Task history",
          type: "item",
          url: "/task-history",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-batch-edit",
          title: "Batch Edit",
          type: "item",
          url: "/batch-edit",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-shift-scheduling",
          title: "Shift scheduling",
          type: "item",
          url: "/shift-scheduling",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-shift-scheduler",
          title: "Shift Scheduler",
          type: "item",
          url: "/shift-scheduler",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-staffing-calendar",
          title: "Staffing calendar",
          type: "item",
          url: "/staffing-calendar",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-master-schedule",
          title: "Master schedule",
          type: "item",
          url: "/master-schedule",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-task-lines",
          title: "Task lines",
          type: "item",
          url: "/task-lines",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-task-assignment",
          title: "Task assignment",
          type: "item",
          url: "/task-assignment",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-task-scheduling",
          title: "Task scheduling",
          type: "item",
          url: "/task-scheduling",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-user-table",
          title: "Staff management",
          type: "item",
          url: "/staff-management",
          icon: icons.TeamOutlined,
        },
        {
          id: "runway-human-resource",
          title: "Human Resource",
          type: "item",
          url: "/human-resource",
          icon: icons.TeamOutlined,
        },
        {
          id: "runway-access-management",
          title: "Access management",
          type: "item",
          url: "/access-management",
          icon: icons.TeamOutlined,
        },
        {
          id: "runway-flights",
          title: "Flights",
          type: "item",
          url: "/flights",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-simulation",
          title: "Simulation",
          type: "item",
          url: "/simulation",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-simulation-2",
          title: "Simulation 2",
          type: "item",
          url: "/simulation-2",
          icon: icons.CalendarOutlined,
        },
        {
          id: "runway-flight-schedule",
          title: "Flight schedule",
          type: "item",
          url: "/flight-schedule",
          icon: icons.CompassOutlined,
        },
        {
          id: "runway-flight-data",
          title: "Flight data",
          type: "item",
          url: "/flight-data",
          icon: icons.CompassOutlined,
        },
      ],
    },
  ],
};

export default runway;
